<template>
  <v-card class="empty-state-card">
    <v-layout
      row
      wrap
      align-center
      justify-center
      class="empty-state-card__content"
    >
      <v-flex v-if="icon" xs2 md3 lg3 class="empty-state-card__icon">
        <i :class="`bexsicon-${icon}`" />
      </v-flex>
      <v-flex :class="'empty-state-card__message ' + messageClass" :style="'padding:' + messagePadding">
        <div v-if="message">
          {{ message }}
        </div>
        <slot v-else name="message"> </slot>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  name: "empty-state-card",
  props: {
    icon: {
      type: String,
    },
    message: String,
    messagePadding: {
         type: String,
         default: "5%"
    },
     messageClass:{
        type: String,
         default: "xs7 md7 lg7"
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/breakpoint";

.empty-state-card {
  margin: 1em 0;
  padding: 16px;

  &__content {
    background-color: #93806c1a;
    @include breakpoint(phone) {
      justify-content: space-between;
    }
  }

  &__icon {
    max-width: 50%;
    font-size: 2.5em;
    align-self: center;
    justify-content: center;
    text-align: right;
    padding-right: 6%;

    i {
      background-color: #fff;
      padding: 0.4em;
      border-radius: 40px;
      margin: 10px;
    }
  }

  &__message {
    font-size: 14px;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/layout/EmptyStateCard.vue